module.exports = __webpack_public_path__ + "src/assets/img/second_icon_2.c9e1a792.svg";